import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CheckboxTreeSelector from '../../../common/components/CheckboxTreeSelector';
import { getSelected } from '../redux/selectors/TransportModesSelectors';
import {
  deSelectAllTransportModes,
  transportModeSelected,
  selectAllTransportModes,
} from '../redux/actions/TransportModeActions';
import TransportModeRadioGroupSelector from './TransportModeRadioGroupSelectorContainer';

export class TransportModeSelectorContainer extends Component {
  componentDidMount() {
    if (this.props.selectAllOnLoad) {
      this.selectAll();
    }
  }

  clearLegsAfterSelect = () => {
    if (this.props.legsToBeClearedAfterSelect && this.props.legsToBeClearedAfterSelect.length) {
      this.props.legsToBeClearedAfterSelect
        .forEach(legCode => this.props.deSelectAllTransportModes(legCode));
    }
  };

  transportModeSelected = (selected) => {
    this.clearLegsAfterSelect();
    this.props.transportModeSelected(this.props.transportMode.legCode, selected);
  };

  selectAll = () => {
    this.clearLegsAfterSelect();
    this.props.selectAllTransportModes(this.props.transportMode.legCode);
  };

  deSelectAll = () =>
    this.props.deSelectAllTransportModes(this.props.transportMode.legCode);

  render() {
    if (this.props.isRadioGroup) {
      return (
        <TransportModeRadioGroupSelector
          title={this.props.transportMode.legName}
          onSelect={this.transportModeSelected}
          nodes={this.props.transportMode.nodes}
          selected={this.props.selected}
        />
      );
    }

    return (
      <CheckboxTreeSelector
        title={this.props.transportMode.legName}
        nodes={this.props.transportMode.nodes}
        onSelect={this.transportModeSelected}
        selected={this.props.selected}
        onSelectAll={this.selectAll}
        onDeSelectAll={this.deSelectAll}
      />
    );
  }
}

function makeMapStateToProps() {
  const mapStateToProps = (state, props) => ({
    selected: getSelected(state, props),
  });
  return mapStateToProps;
}

const mapDispatchToProps = dispatch => bindActionCreators({
  transportModeSelected,
  selectAllTransportModes,
  deSelectAllTransportModes,
}, dispatch);

TransportModeSelectorContainer.propTypes = {
  transportModeSelected: PropTypes.func,
  transportMode: PropTypes.objectOf(PropTypes.shape),
  selectAllTransportModes: PropTypes.func,
  deSelectAllTransportModes: PropTypes.func,
  selected: PropTypes.arrayOf(PropTypes.string),
  selectAllOnLoad: PropTypes.bool,
  isRadioGroup: PropTypes.bool,
  legsToBeClearedAfterSelect: PropTypes.arrayOf(PropTypes.string),
};

export default connect(makeMapStateToProps, mapDispatchToProps)(TransportModeSelectorContainer);

